import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import '../../assets/css/Contact.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { ContactApi } from '../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
// import { EditNotifications } from '@mui/icons-material';
// import ProfileTab from '../../Components/Profile/ProfileTabs';
// import '../../assets/css/AboutUs.css';
// import '../../assets/css/Packages.css'
// import {  useNavigate } from 'react-router-dom';

const Contact = () => {
    // let navigate = useNavigate();
    let dispatch = useDispatch();
    const [state, setState] = useState({
        name: "", email: "", cname: "", message: ""
    });
    let [phone, setPhone] = useState("")
    const [siteSetting, setSiteSetting] = useState(null);

    const InputVal = (e) => {
        let { name, value } = e.target;
        setState({ ...state, [name]: value });
    }
    const InputVal2 = (e) => {
        const limit = 17;
        setPhone(e.target.value.slice(0, limit))
    }

    let ResData = {
        full_name: state.name,
        email: state.email,
        company_name: state.cname,
        description: state.message,
        phone_no: phone,
    }

    const SubmitData = (e) => {
        e.preventDefault();
        dispatch(ContactApi(ResData))
            .then((res) => {
                // console.log("data contact send", res);
                toast.success("Your Message Has Been Sent Successfully");
                setState({ name: "", email: "", cname: "", country: "", message: "" })
                setPhone("")
            })
            .catch((e) => { console.log('error from catch ', e) })
    }

    useEffect(() => {
        window.scroll(0, 0);
        setTimeout(() => {
            if (localStorage.getItem('siteSettings')) {
                setSiteSetting(JSON.parse(localStorage.getItem('siteSettings')));
            }
        }, 1500);
    }, [])

    return (
        <div className='Contact packages'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"CONTACT ME"} />
            </section>
            <section className='pkg_content'>
                <div className='container'>
                    <div>
                        <h4 className='sub-title mt-5'>Contact me </h4>
                        <h2 className='main-title'>I’m your savior and guide</h2>
                        <div className="border-btm-pink-secondsec mt-3 mb-4"></div>
                        <p className='main-para'>
                            If you have any questions related to the tips, our sport betting predicting methods, insights or you just want to get more information on an upcoming match, feel free to contact me by filling out the form below. I will do my best to respond and clear any query that you may have.
                        </p>
                    </div>
                    <form onSubmit={SubmitData}>
                        <div className='row form-container'>
                            <div className='col-md-6 mt-4'>
                                <label className='label-input'>Your Name</label>
                                <input
                                    required
                                    value={state.name} onChange={InputVal} name="name"
                                    type="text" placeholder='Julia William' minLength={3} maxLength={50} />
                            </div>
                            <div className='col-md-6 mt-4'>
                                <label className='label-input'>Email Address</label>
                                <input
                                    value={state.email} onChange={InputVal} name="email"
                                    required
                                    type="email" placeholder='you@example.com' />
                            </div>
                            <div className='col-md-6 mt-4'>
                                <label className='label-input'>Company Name</label>
                                <input
                                    value={state.cname} onChange={InputVal} name="cname"
                                    required
                                    type="text" placeholder='Company name' minLength={3} maxLength={50} />
                            </div>
                            <div className='col-md-6 mt-4'>
                                <label className='label-input'>Contact Number</label>
                                <input
                                    value={phone} onChange={InputVal2}
                                    type='number' placeholder='123456789' name='phone' required />
                                {/* <select
                                    value={state.country} onChange={InputVal} name="country"
                                    required
                                >
                                    <option value="Country">Country</option>
                                    <option value="Country">Country</option>
                                    <option value="Country">Country</option>
                                    <option value="Country">Country</option>
                                </select> */}
                            </div>
                            <div className='col-md-12 mt-4'>
                                <label className='label-input'>Your Message.</label>
                                <textarea
                                    value={state.message} onChange={InputVal} name="message"
                                    required
                                    placeholder='Type your message….' ></textarea>
                            </div>
                            <div>
                                <p className='para-end mt-3'>By submitting this form you agree to our terms and conditions and our Privacy Policy which explains how we may collect, use and disclose your personal information including to third parties.</p>
                            </div>
                            <div className='col-md-12 btn-container mt-4'>
                                <button type='submit' className='btn btn-submit rounded-0' >Submit</button>
                            </div>
                        </div>
                    </form>
                    <div className='row contact-info'>
                        <div className='col-md-4'>
                            <div className='main-container'>
                                <div className='icon-container'>
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        className="closeIcon"
                                    />
                                </div>
                            </div>
                            <p className='title'>Email us</p>
                            <p className='desc'>Email us for general queries, including marketing and partnership opportunities.</p>
                            <p className='address'>
                                {/* predictiondog@gmail.com */}
                                {siteSetting?.[0]?.contact_email}
                            </p>
                        </div>
                        <div className='col-md-4'>
                            <div className='main-container'>
                                <div className='icon-container'>
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        className="closeIcon"
                                    />
                                </div>
                            </div>
                            <p className='title'>Call us</p>
                            <p className='desc'>Call us to speak to a member of our team. We are always happy to help.</p>
                            <p className='address'>
                                {/* 423-315-2860 */}
                                {siteSetting?.[0]?.contact_phone}
                            </p>
                        </div>
                        <div className='col-md-4'>
                            <div className='main-container'>
                                <div className='icon-container'>
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className="closeIcon"
                                    />
                                </div>
                            </div>

                            <p className='title'>Find us</p>
                            <p className='desc'>
                                {/* 79 College Road,Harrow, <br />HA1 1BD */}
                                {siteSetting?.[0]?.address}
                            </p>
                            <p className='address'>Support Center</p>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    )
}

export default Contact;
